import { FinnishSSN } from 'finnish-ssn';

const EMAIL = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([a-zA-Z-0-9]+\.)+[a-zA-Z]{2,})$/;
const TEL = /^(\+{0,1}([0-9]{3,5}((-{0,1})([0-9]{1,12})$)))/;
const WHITESPACE = /\s/g;

export const validateTelephone = (phone: string): boolean => {
  const input = phone.replace(WHITESPACE, '');
  return TEL.test(input);
};

export const validateEmail = (email: string): boolean => {
  return EMAIL.test(email);
};

export const validatePersonalIdentificationNumber = (pid: string): boolean => {
  return FinnishSSN.validate(pid);
};

export default {
  validateTelephone,
  validateEmail,
  validatePersonalIdentificationNumber,
};
